"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import React from "react";
import { observer } from "mobx-react";
import { computed, observable } from "mobx";
import Slider, { SliderTheme } from "./Slider/Slider";
import { randomString } from "../../../utils";
var SliderInput = /*#__PURE__*/function (_React$Component) {
  _inherits(SliderInput, _React$Component);
  var _super = _createSuper(SliderInput);
  function SliderInput(props) {
    var _this;
    _classCallCheck(this, SliderInput);
    _this = _super.call(this, props);
    _this.baseId = "slider-".concat(randomString());
    _this.labelId = "".concat(_this.baseId, "-label");
    _this.onSliderChange = function (newValue) {
      _this.rangeInputValue = newValue;
      _this.textInputValue = newValue.toString();
      _this.props.handleValueChange(newValue);
    };
    _this.onTextInputChange = function (event) {
      var inputValue = Number(event.target.value);
      if (isNaN(inputValue)) {
        return;
      }
      var minimum = _this.props.minimum;
      var validInputValue = _this.getValidInputValue(inputValue, minimum);
      if (event.target.value.endsWith(".")) {
        _this.textInputValue = event.target.value;
        _this.rangeInputValue = validInputValue;
      } else {
        _this.textInputValue = inputValue.toString();
        _this.rangeInputValue = validInputValue;
      }
      _this.props.handleValueChange(validInputValue);
    };
    _this.onTextInputBlur = function () {
      if (_this.props.minimum != void 0 && _this.isBelowMin(Number(_this.textInputValue))) {
        _this.textInputValue = _this.props.minimum.toString();
      }
    };
    _this.onKeyPressed = function (event) {
      if (event.key === "Enter") {
        event.target.blur();
      }
    };
    _this.getValidInputValue = function (inputValue, minimum) {
      if (minimum != void 0 && _this.isBelowMin(inputValue)) {
        return minimum;
      } else if (_this.isAboveMax(inputValue)) {
        return _this.maximum;
      } else {
        return inputValue;
      }
    };
    _this.rangeInputValue = _this.props.initialInputValue;
    _this.textInputValue = _this.props.initialInputValue.toString();
    return _this;
  }
  _createClass(SliderInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        theme = _this$props.theme,
        unit = _this$props.unit,
        minimum = _this$props.minimum,
        sliderEventHandlers = _this$props.sliderEventHandlers;
      return /* @__PURE__ */React.createElement("div", {
        className: classNames({
          "slider-input": true,
          "slider-input--dark": theme === SliderTheme.Dark
        })
      }, /* @__PURE__ */React.createElement("div", {
        className: "slider-input__input-container"
      }, /* @__PURE__ */React.createElement("label", {
        className: "slider-input__label",
        htmlFor: "".concat(this.baseId, "-text-input"),
        id: this.labelId
      }, label, /* @__PURE__ */React.createElement("span", {
        className: "slider-input__unit"
      }, unit)), /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement("input", {
        className: "slider-input__text-input",
        type: "text",
        onChange: this.onTextInputChange,
        onBlur: this.onTextInputBlur,
        onKeyPress: this.onKeyPressed,
        value: this.textInputValue,
        id: "".concat(this.baseId, "-text-input"),
        "aria-labelledby": this.labelId
      }))), /* @__PURE__ */React.createElement("div", {
        className: "slider-input__input-container"
      }, /* @__PURE__ */React.createElement(Slider, __spreadValues({
        value: this.rangeInputValue,
        minimum: minimum,
        maximum: this.maximum,
        theme: theme,
        onChange: this.onSliderChange,
        label: unit ? "".concat(label, " ").concat(unit) : label
      }, sliderEventHandlers))));
    }
  }, {
    key: "isBelowMin",
    value: function isBelowMin(inputValue) {
      return this.props.minimum != void 0 && this.props.minimum > inputValue;
    }
  }, {
    key: "isAboveMax",
    value: function isAboveMax(inputValue) {
      return inputValue > this.maximum;
    }
  }, {
    key: "maximum",
    get: function get() {
      var _a;
      return (_a = this.props.maximum) != null ? _a : 100;
    }
  }]);
  return SliderInput;
}(React.Component);
SliderInput.defaultProps = {
  initialInputValue: 25,
  theme: SliderTheme.Light,
  minimum: 0,
  handleValueChange: function handleValueChange() {}
};
__decorateClass([observable], SliderInput.prototype, "rangeInputValue", 2);
__decorateClass([observable], SliderInput.prototype, "textInputValue", 2);
__decorateClass([computed], SliderInput.prototype, "maximum", 1);
SliderInput = __decorateClass([observer], SliderInput);
export default SliderInput;